import { Component, Input } from '@angular/core';
import { IReportCountProgress } from 'src/app/interfaces/IReportCountProgress';

@Component({
  selector: 'app-district-header-card',
  templateUrl: './district-header-card.component.html',
  styleUrls: ['./district-header-card.component.scss']
})
export class DistrictHeaderCardComponent {
  @Input() districtName: string = '';
  @Input() isFinal: boolean = false;
  @Input() lastUpdate: Date = new Date();
  @Input() countProgress: IReportCountProgress | null = null;

  public provisionalDisclaimer = 'Please note, results are provisional. Results will be published progressively. The figures below may not include all votes.';
  public finalDisclaimer = 'The counting of votes for this election is now concluded. All votes have been counted and the results are final.';
}
